"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IdentifierNamesGenerator_1 = require("../../enums/generators/identifier-names-generators/IdentifierNamesGenerator");
exports.IdentifierNamesGeneratorSanitizer = (value) => {
    const isCorrectIdentifierNamesGenerator = Object
        .keys(IdentifierNamesGenerator_1.IdentifierNamesGenerator)
        .some((key) => {
        return IdentifierNamesGenerator_1.IdentifierNamesGenerator[key] === value;
    });
    if (!isCorrectIdentifierNamesGenerator) {
        throw new ReferenceError('Invalid value of `--identifier-names-generator` option');
    }
    return value;
};
